$(document).ready(function(e){

    
function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


  var moneyFormat= $('body').attr('data-mf');
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

   
    // $('.new-arrval-slider .item').each(function(i,item){
    //   var ctPlus = 1, liLength = $(item).find('.color-box:not(.current_active_color)').length;
    //   $(item).find('.color-box:not(.current_active_color)').each(function(idx,ele){
    //     var handle = $(ele).attr('data-handle'), newIDx = idx + 1;
    //     $.get('/products/'+handle+'?view=xyz', function(data) {
    //         $(ele).html(data);
          
    //         ctPlus = ctPlus + 1;
          
    //         var inputID = $(ele).find('.color-id').attr('input-id') + newIDx;
    //         $(ele).find('.color-id').attr('input-id', inputID)
    //         console.log(inputID, 'inputID',ctPlus);
          
    //         if (liLength == (idx + 1)) {
    //           console.log(ctPlus);
    //           if (ctPlus < 5) $(item).find('.swatch_col_plus').hide();
    //         }
    //     }).fail(function() {
    //       ctPlus = ctPlus - 1;
    //       $(ele).hide();
    //     });
    //   });
      
    // });
      

      
    $('.new-arrval-slider .item').each(function(i,item){
      var handle = $(item).find('.product-card').attr('data-handle');
      $(item).find('.pc-color-box').each(function(idx,ele){
        $.get('/products/'+handle+'?view=xyz', function(data) {
            $(ele).html(data);
        })
      });
    });
    // if($('#isp_search_results_container').length > 0){
    //   console.log('4444')
    //   $('.isp_grid_product .product-card').each(function(i,item){
    //     console.log(item,'item')
    //     get_json(item);
    //   });
    // }
  function getall_collection_grid(){
    if($('.collection_wrapper ').length > 0){
      $('.collection_wrapper .product-card').each(function(){
        var getProductData = JSON.parse($(this).find('.color-box.current_active_color .product_json[type="application/json"]').text());
        var $this=$(this);
        set_collection_img(getProductData,$this);
      });
    }
    if($('#isp_search_results_container').length > 0){
      $('.isp_grid_product .product-card').each(function(){
        var getProductData = JSON.parse($(this).find('.color-box.current_active_color .product_json[type="application/json"]').text());
        var $this=$(this);
        set_collection_img(getProductData,$this);
      });
    }
    if($('.pr_left_new ').length > 0){
      $('.pr_inner_new .pr_left_new .bundle-product-card').each(function(){
        var getProductData = JSON.parse($(this).find('.color-box.current_active_color .product_json[type="application/json"]').text());
        var $this=$(this);
        set_collection_img(getProductData,$this);
      });
    }
  }

  function loadpagefilter(){
    if($(".filter_trigger").length > 0){
      $(".filter_trigger").removeClass("btn_active");
      $('.coll_filter, body').removeClass('avtive_mob_filter').removeClass('avtive_filter');
      $('.Collection_Main_Wrapper').removeClass('avtive_filter');
    }else{
      setTimeout(function(){
        loadpagefilter();
      },1000);
    }
  }
  function loadpagetag(){
    if ($(window).width() < 767) {
      if($(".filter_header").length > 0){
        $(".filter_header").removeClass("active");
        $(".filter_content").slideUp();
        $(".filter_header:eq(0)").addClass('active');
        $(".filter_header:eq(0)").next().slideDown();
      }else{
        setTimeout(function(){
          loadpagetag();
        },1000);
      }
    }
  }
  function menu() {
    var memberAreaWidth = jQuery(window).width();
    if (memberAreaWidth <= 767) {
      $(".footer-link-block ul").hide();
      $(".search-box").addClass("r-search");
      $('.coll_filter').removeClass('active_filter');
    } else {
      $(".footer-link-block ul").show();
      $(".search-box").removeClass("r-search");
    }
  }

  function setlocalfor_coll_viewall(){
//     if($('[data-collection-template]').length> 0){
//       var prevAccepted = localStorage.getItem("accepted_view_all");
//       var scurrentTime = new Date().getTime();
//       var expireTime = parseInt(prevAccepted)+ 1000 * 60 * 60 * 24 ;
//       var remove_local = false;

//       if((prevAccepted != undefined)&&(prevAccepted != null)){
//         if(scurrentTime > expireTime){
//           localStorage.removeItem('accepted_view_all');
//           $('.coll_grid, body').removeClass('active-menu');
//           console.log('***');
//           console.log($('.viewall-btn option[value="grid_view"]'));
//           $('.viewall-btn option[value="grid_view"]').prop('selected',true);

//         }else{
//           $('.coll_grid, body').addClass('active-menu');
//           $('.viewall-btn option[value="list_view"]').prop('selected',true);
//         }
//       }
//     }
  }

  function product_image_slider($product_slider){
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 767) {
      if ($product_slider.hasClass('slick-initialized')) {
        $product_slider.slick('unslick');
      }
    } else {
      if (!$product_slider.hasClass('slick-initialized')) {
        $product_slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          dots: true,
          arrows: false,
          adaptiveHeight: true
        });
      }else{
        $product_slider.slick('unslick');
        $product_slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          dots: true,
          arrows: false,
          adaptiveHeight: true
        });
      }
    }
  }

  function blogtag_grid(href){
    $.get( href, function( data ) {
      $('.blog-sec').html($(data).find('.blog-sec').html());
    });
    var currentURL = window.location.href;
    window.history.replaceState(null, null, href);
  }

  function refreshZoom() {
    if($('.pdp-img-item figure').length < 1){
      MagicZoom.refresh();
    }else{
      setTimeout(function(){
        refreshZoom();
      },1000);
    }
  }
  function createSticky(sticky) { 
    var headerV2 = $('#HeaderV2');
    var header_height = 0;
    if(headerV2.length > 0){
      header_height = $("#HeaderV2").outerHeight() + $("#PromoBarWrapper").outerHeight();
    } else {
      var header_height = $('header').outerHeight();
    }
    $('.stickybtn_wp').css("top", header_height+"px").css("display","flex");
    var	win = $(window);
    win.on("scroll", function() {
      var	pos = sticky.offset().top + sticky.height();    
      if(win.scrollTop() >= pos){
        $('.stickybtn_wp').addClass("fixed");

      }else{
        $('.stickybtn_wp').removeClass("fixed");      
      }
    });	
  }

  function UpdateProductButton($this,selected_available,product_id){
    $('.preorder_msg').remove();
    var id = $this.parents('.pa-detail-grid').find('.product-template-swatch input[type="radio"]:checked').attr('data-var-id')
    if(selected_available == 'available'){
      $this.parents('.pa-detail-grid').find('.trigger_by_sticky[atc_btn]').prop('disabled',false).show();
      $this.parents('.pa-detail-grid').find('.sticky_addtocart[atc_btn]').removeClass('sticky-disabled-btn').show();
      $this.parents('.pa-detail-grid').find('.form-klaviyo-bis').hide();
    }else if(selected_available == 'preorder'){
      $this.parents('.pa-detail-grid').find('.trigger_by_sticky[atc_btn]').prop('disabled',false).show();
      $this.parents('.pa-detail-grid').find('.sticky_addtocart[atc_btn]').removeClass('sticky-disabled-btn').show();
      $this.parents('.pa-detail-grid').find('.form-klaviyo-bis').hide();
      console.log($this.parents('.pa-detail-grid').find('.pdp-select-size input[type="radio"]:checked').attr('data-var-id'));
      var data = '<div class="preorder_msg">'+$this.parents('.pa-detail-grid').find('.product-template-swatch input[type="radio"]:checked').parents('li').attr('data-preorder-info')+'</div>';
      $this.parents('.pa-detail-grid').find('.pdp-submit').before(data);
    }else{
      $this.parents('.pa-detail-grid').find('.pdp-submit [atc_btn]').hide();
      $this.parents('.pa-detail-grid').find('.trigger_by_sticky[atc_btn]').prop('disabled',true).hide();
      $this.parents('.pa-detail-grid').find('.sticky_addtocart[atc_btn]').addClass('sticky-disabled-btn');
      $this.parents('.pa-detail-grid').find('.form-klaviyo-bis').attr('data-product-id',product_id).attr('data-variant-id',id).show();
    }
    var btn_text = $this.parents('.pdp-detail-list').find('[atc_btn] span').attr(selected_available);
    $this.parents('.pa-detail-grid').find('[atc_btn] span').text(btn_text);
  }
  
  function collectionSlider(){
    $('.cart-collection-slider').slick({
      dots: false,
      infinite: true,
      speed: 100,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      swipeToSlide: true,
      waitForAnimate: false,
      touchThreshold: 100,
      prevArrow: $('.n-prev-arrow'),
      nextArrow: $('.n-next-arrow'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 2
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
  // function addToCartSuccess() {
  //   $.get("/cart?view=minicart", function( data ) {
  //     $('#crt').html(data);
  //     collectionSlider();
  //   });
  //   //     $('.quick-cart-item').removeClass('loading');
  // }
  function addToCartSuccess() {
    // const nostoCartWrapper = $('.cartDrawer .nosto_element');
    // let nostoChild = nostoCartWrapper.children().detach(); 

    // $.get("/cart?view=minicart", function(data) {
    //     $('#crt').html(data);

    //     // Re-target the new nosto_element inside #crt
    //     const newNostoID = $('.cartDrawer .nosto_element').attr('id');
    //     if (newNostoID) {
    //       Nosto.reloadCart([`${newNostoID}`]);
    //     }

    //     //Secure Checkout
    //     window.updateCheckoutButton();
    // });

    const cartDrawer = document.getElementById('CartDrawer');
    cartDrawer.open();

  }
  window.bogosATC = addToCartSuccess;
  
  function refreshCart(cart) {
    if(cart.item_count > 0 ){
      $('header .cart').addClass('active_cart');
      $('.cart_count').text(cart.item_count);
    }else{
      $('header .cart').removeClass('active_cart');
      $('.cart_count').text(cart.item_count);
    }
  }

  function updateCartEvent(data, event, ip) {
    if (data) {
      var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
      var size = data.variant_options.length > 1 ? data.variant_options[1].trim() : '';
      var dataEvent = {
        event: "updateCart",
      }
      if (ip) {
        var qty = ip;
      } else {
        var qty = data.quantity;
      }
      if (event == 'add') {
        dataEvent.addToCart = {
          products: [
            {
              id: data.product_id,
              sku: data.variant_id,
              style: data.sku,
              name: data.title,
              price: (parseInt(data.final_price)/100).toFixed(2),
              basePrice: (parseInt(data.original_price)/100).toFixed(2),
              quantity: qty,
              brand: data.vendor,			
              color: data.variant_options[0].trim(),
              colorFamily: data.variant_options[0].trim(),
              size: size,
              expectedShipDate: expectedShipDate
            }
          ]
        }
      } else {
        dataEvent.removeFromCart = {
          products: [
            {
              id: data.product_id,
              sku: data.variant_id,
              style: data.sku,
              name: data.title,
              price: (parseInt(data.final_price)/100).toFixed(2),
              basePrice: (parseInt(data.original_price)/100).toFixed(2),
              quantity: qty,
              brand: data.vendor,			
              color: data.variant_options[0].trim(),
              colorFamily: data.variant_options[0].trim(),
              size: size,
              expectedShipDate: expectedShipDate
            }
          ]
        }
      }
      $.getJSON('/cart.js', function(c) {
        dataEvent.cart = {
          "total": c.total_price,
          "count": c.item_count,
          "products": []
        }
        $(c.items).each(function(i, v) {
          var expectedShipDate = v.properties != null ? v.properties['EXPECTED SHIP DATE'] != null ? v.properties['EXPECTED SHIP DATE'] : '' : '';
          var size = v.variant_options.length > 1 ? v.variant_options[1].trim() : '';
          dataEvent.cart.products.push({
            id: v.product_id,
            sku: v.variant_id,
            style: v.sku,
            name: v.title,
            price: (parseInt(v.final_price)/100).toFixed(2),
            basePrice: (parseInt(v.original_price)/100).toFixed(2),
            quantity: v.quantity,
            brand: v.vendor,			
            color: v.variant_options[0].trim(),
            colorFamily: v.variant_options[0].trim(),
            size: size,
            expectedShipDate: expectedShipDate
          });
        });
        dataEvent._clear = true;
        window.dataLayer.push(dataEvent);
      });
    }
  }

  // Execute on load
  menu();
  loadpagetag();
  setlocalfor_coll_viewall();

  function freeGift(cart, page) {
    var free_item = $(cart.items).filter(function( index, cont ) {                    
      if(cont.properties != null){
        return cont.properties['_free'] == 'free_product';
      }
    });
    if (typeof window.gift != 'undefined') {
      if (window.gift.free_gift && window.gift.free_gift_product != '') {
      var id = window.gift.free_gift_product;
      if (cart.item_count > 0 && free_item.length == 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: id, quantity: 1, properties: { '_free': 'free_product' } },
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            $this.parents('.pdp-size').append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
          }
        }).done(function( data ) {
          addToCartSuccess();
          $.getJSON('/cart.js', function(cart){
            refreshCart(cart);
          });
        });
      } else if (cart.item_count == 1 && free_item.length > 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: 'updates['+id+']='+0,
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            alert(response.description);
            $this.parents('.quick-cart-item').removeClass('loading');
          }
        }).done(function( data ) {
          if (page) {
            $.get( "/cart?view=alternate", function( data ) {
              $('#crt').html(data);
            });
          } else {
            addToCartSuccess();
          }
          $.getJSON("/cart.js", function(cart) {
            refreshCart(cart);
          });
        });
      }
    }
    }
  }

  $('body').on('click','.Product_add_to_cart',function(e){
    e.preventDefault();
    var $this = $(this),preorder='';
    
    var id = $this.parents('.pdp-select-size').find('.product-template-swatch input[type="radio"]:checked').attr('data-var-id');
    if($this.parents('.pdp-select-size').find('.product-template-swatch input[type="radio"]:checked').parents('li').hasClass('preorder')){
      preorder = $this.parents('.pdp-select-size').find('.product-template-swatch input[type="radio"]:checked').parents('li').attr('data-preorder-cart');
    }
    $this.parents('.pdp-size').find('.error').remove();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:id,quantity:1,properties:{ 'preorder' : preorder }},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        $this.parents('.pdp-size').append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      }
    }).done(function( data ) {
      addToCartSuccess();
      // $.getJSON('/cart.js', function(cart){
      //   refreshCart(cart);
      //   freeGift(cart);
      // });
      // $('.productGrid .productItem').removeClass('qvopen');
      // $('body').addClass('cartOpen');
      // $('.fullPage').addClass('witmenu');

      var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
      var size = data.variant_options.length > 1 ? data.variant_options[1].trim() : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: 'Product Page',
        product: {
          id: data.product_id,
          sku: data.variant_id,
          style: data.sku,
          name: data.title,
          price: (parseInt(data.final_price)/100).toFixed(2),
          basePrice: (parseInt(data.original_price)/100).toFixed(2),
          quantity: data.quantity,
          brand: data.vendor,			
          color: data.variant_options[0].trim(),
          colorFamily: data.variant_options[0].trim(),
          size: size,
          expectedShipDate: expectedShipDate
        },
        productRaw: JSON.parse($('#product_json').html())
      });
      setTimeout(function() {
        updateCartEvent(data, 'add', 1)
      }, 1000)
      cartUpsellitems();
    });
  });

  $('body').on('click','.bundle_add_to_cart',function(e){
    e.preventDefault();
	var $this = $(this).parents('section'), btn_this = $(this);
    $('.Bundle_error').remove();
    $this.find('.bundle_add_error').remove();
    var checkedInputs = $this.find('.bundle-product-card').find('.Bundle_Product_swatch input[type="radio"]:checked');
    if($this.find('.bundle-product-card').find('.Bundle_Product_swatch input[type="radio"]:checked').length < 2 ){
      $(this).after('<p class="Bundle_error">Please Select both Product</p>')
    }else if($this.find('.bundle-product-card').find('.Bundle_Product_swatch input[type="radio"]:checked').length == 2){
      var bundle_size_1 = $(checkedInputs[0]).val();
      var bundle_size_2 = $(checkedInputs[1]).val();
      if (bundle_size_1 === bundle_size_2) {
        $.getJSON('/cart.json',function(cart){
        var all_current_items = [],all_current_items_pid = [],cart_bundle = false;
        $(cart.items).each(function(ii,cc){
          if(cc.properties['bundle_uniqid'] == 'custom_bundle'){
            cart_bundle = true;
          }
          if(typeof cc.properties['bundle_id'] !== 'undefined'){
            all_current_items.push(cc.id);
            all_current_items_pid.push(cc.product_id);
          }
        });
      if(cart_bundle == false){
        var JSONObj = [],colorobj = [];
        var total_pro = $this.find('.bundle-product-card').length;
        var selected_pro = $this.find('.bundle-product-card').find('.Bundle_Product_swatch input[type="radio"]:checked').length;
        var uniq_id = Math.round(Date.now() / 1000);
        $this.find('.bundle-product-card').each(function(){
          var bv_id = Number($(this).find('.Bundle_Product_swatch input[type="radio"]:checked').attr('data-var-id'));
          var colid = Number($(this).find('.color-box.current_active_color .color-id').attr('dataid'));
          if((all_current_items.indexOf(bv_id) > -1)||(all_current_items_pid.indexOf(colid) > -1)){
            $('.Bundle_error').remove();
            btn_this.after('<p class="Bundle_error">Selected color and size is already in cart. Please select a different color and size.</p>');
            return false;
          }
          
          colorobj.push(colid);
          var preorder,already=false;
          if($(this).find('.Bundle_Product_swatch input[type="radio"]:checked').parents('li').hasClass('preorder')){
            preorder = $(this).find('.Bundle_Product_swatch input[type="radio"]:checked').parents('li').attr('data-preorder-cart');
          }
          JSONObj.push({
            quantity: 1,
            id: bv_id,
            "properties":{
              "preorder":preorder,
              "bundle_uniqid": 'custom_bundle',
              "bundle_id": uniq_id
            }
          });
        });
        if((JSONObj[0].id != JSONObj[1].id)&&(colorobj[0] == colorobj[1])){
          $('.Bundle_error').remove();
          btn_this.after('<p class="Bundle_error">Both selected colors are same. Please select different colors to achieve bundle.</p>');
          return false;
        }else if(JSONObj.length == 2){
          jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                items : JSONObj
              },
              async: false,  
              dataType: 'json',
              error: function(jqXHR, textStatus, errorThrown){
                if(jqXHR) {
                  var response = jQuery.parseJSON(jqXHR.responseText);
                  btn_this.after('<p class="Bundle_error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
                }
                btn_this.after('<p class="Bundle_error">Something went wrong. Please try again later.</p>')
              }
          }).done(function( data ) {
              addToCartSuccess();
              $.getJSON('/cart.js', function(cart){
                refreshCart(cart);
                freeGift(cart);
              });
              $('.productGrid .productItem').removeClass('qvopen');
              $('body').addClass('cartOpen');
              $('.fullPage').addClass('witmenu');
              console.log(data, '6666666');
              var dataLayerUpsellProducts = [], createupsellDataLayerProduct = {};
              for (var i = 0; i < data.items.length; i++){
                var size = data.items[i].variant_options.length > 1 ? data.items[i].variant_options[1].trim() : '';
                var objUpsell = {
                    id: data.items[i].product_id,
                    sku: data.items[i].variant_id,
                    style: data.items[i].sku,
                    name: data.items[i].title,
                    price: (parseInt(data.items[i].final_price)/100).toFixed(2),
                    basePrice: (parseInt(data.items[i].original_price)/100).toFixed(2),
                    quantity: data.items[i].quantity,
                    brand: data.items[i].vendor,			
                    color: data.items[i].variant_options[0].trim(),
                    colorFamily: data.items[i].variant_options[0].trim(),
                    size: size
                }
                dataLayerUpsellProducts.push(objUpsell)
              }
              if (dataLayerUpsellProducts.length != 0 || dataLayerUpsellProducts != undefined){
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "addToCart",
                  addToCartLocation: 'Bundle Page',
                  addToCart: {
                      name: $('.product_add_sec').data('page-handle') + ' page',
                      products: dataLayerUpsellProducts,
                  }
                })
              }
          });
        }
        setTimeout(function(){
          $('.Bundle_error').remove();
        },5000);
        }else{
         btn_this.after('<p class="Bundle_error">Offer is limited to one bundle per customer.</p>') 
       }
      });
      }else{
        btn_this.after('<p class="Bundle_error">Please select the same size for both products.</p>')
      }
    }
  });
  
  $('body').on('change','.coll-product-swatch:not(.cart-drawer) input[type="radio"]',function(e){
    e.preventDefault();
    var $this = $(this),preorder='';
    var id = $this.attr('data-var-id');
    var pid = $this.attr('data-product-id');
    var mprice = parseInt($this.attr('data-main-price'));
    var cprice = parseInt($this.attr('data-compare-price'));
    var pname = $this.parents('.pc-detail').find('.pc-name').text();
    $this.parents('.q-add-label').find('.error').remove();
    var atcLocation = '';
    var thisJSON = $(this).parents('.product-card').find('.color-box.current_active_color .product_json[type="application/json"]').html();
    if ($this.parents('.cart-upsell-collection').length != 0){
      atcLocation = 'Mini-Cart'
    } else {
      atcLocation = $('body').data('template-name');
    }
    if(cprice > mprice){
      $this.parents('.pc-detail').find('.pc-price-wp').addClass('has_compare_price');
      $this.parents('.pc-detail').find('.pc-price-wp [data_main_price]').text((formatMoney(mprice, moneyFormat)).replaceAll('"',''));
      $this.parents('.pc-detail').find('.pc-price-wp [data_compare_price]').text((formatMoney(cprice, moneyFormat)).replaceAll('"','')).show();
    }else{
      $this.parents('.pc-detail').find('.pc-price-wp').removeClass('has_compare_price');
      $this.parents('.pc-detail').find('.pc-price-wp [data_main_price]').text((formatMoney(mprice, moneyFormat)).replaceAll('"',''));
      $this.parents('.pc-detail').find('.pc-price-wp [data_compare_price]').text('').hide();
    }
    if($this.parents('.coll-product-swatch').hasClass('Bundle_Product_swatch')){
      $this.parents('.template--product').find('.bundle_add_to_cart').prop('disabled',false);
      var bundle_price=0;
      $this.parents('.product_add_sec').find('.Bundle_Product_swatch input[type="radio"]:checked').each(function(){
        bundle_price+=parseInt($(this).attr('data-main-price'));
      });
      var bafterpay_price = bundle_price/4;
//       $this.parents('.product_add_sec').find('.bundle_add_to_cart_price').text(' - '+(formatMoney(bundle_price, moneyFormat)).replaceAll('"',''));
//       $this.parents('.product_add_sec').find('.pdp-after-pay').show().find('.afterpay_price').text((formatMoney(bafterpay_price, moneyFormat)).replaceAll('"',''));
    }else{
    if(($this.parents('li').hasClass('available'))||$this.parents('li').hasClass('preorder')){
      if($this.parents('li').hasClass('preorder')){
        preorder = $this.parents('li').attr('data-preorder-cart');
      var data = {id:id,quantity:1,properties:{'preorder' : preorder}};
      }else{
      var data = {id:id,quantity:1};
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          $this.parents('.q-add-label').append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
          setTimeout(function(){
            $this.parents('.q-add-label').find('.error').remove();
          },5000);
        }
      }).done(function( data ){
        addToCartSuccess();
        // $.getJSON('/cart.js', function(cart){
        //   refreshCart(cart);
        //   freeGift(cart);
        // });
        // $this.parents('ul').find('input[type=radio]').prop('checked', false);
        // $('.productGrid .productItem').removeClass('qvopen');
        // $('body').addClass('cartOpen');
        // $('.fullPage').addClass('witmenu');
        
        var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
        var size = data.variant_options.length > 1 ? data.variant_options[1].trim() : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'addToCart',
          addToCartLocation: atcLocation,
          product: {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: data.quantity,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size: size,
            expectedShipDate: expectedShipDate
          },
          productRaw: JSON.parse(thisJSON)
        });
        setTimeout(function() {
          updateCartEvent(data, 'add', 1)
        }, 1000);
        if ($this.parents('.cart-collection-slider').length == 0){
          cartUpsellitems();
        }
      });
    }else{
      var $notify_popup=$('body').find('.collection_notify_popup');
      $notify_popup.addClass('active-notify');
      $notify_popup.find('.Product_name').text(pname);
      $notify_popup.find('.form-klaviyo-bis').attr('data-variant-id',$this.attr('data-var-id'));
      $notify_popup.find('.form-klaviyo-bis').attr('data-product-id',$this.attr('data-product-id'));
      $('.notify-overlay, body').addClass('active-notify');
    }
  }

  });


  // $('body').on('click', '.qtyAdjust .adjust',function(){
  //   var $this =$(this);
  //   var input = $(this).parent().find('input');
  //   var ip = parseInt(input.val());
  //   var event = '';
  //   if($(this).hasClass('plus')) {
  //     ip = ip + 1;
  //     event = 'add';
  //   } else {
  //     ip = ip - 1;
  //     event = 'remove';
  //   }
  //   if(ip==0) {
  //     return false;
  //   }
  //   input.val(ip);

  //   $this.parents('.quick-cart-item').addClass('loading');
  //   var id = parseInt(input.attr('data-id'));
  //   var item = [];
  //   $.getJSON('/cart.js', function(cart) {
  //     var c = $(cart.items).filter(function(index, cont) {                    
  //       return cont.id == id;
  //     });
  //     item.push(c[0]);
  //   });
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/update.js',
  //     data: 'updates['+id+']='+ip,
  //     dataType: 'json',
  //     error: function(jqXHR, textStatus, errorThrown){
  //       var response = $.parseJSON(jqXHR.responseText);
  //       alert(response.description);
  //       $this.parents('.quick-cart-item').removeClass('loading');
  //     }
  //   }).done(function( data ) {
  //     addToCartSuccess();
  //     $.getJSON("/cart.js", function(cart) {
  //       refreshCart(cart);
  //       freeGift(cart);
  //     });
  //     for (var i = 0 ; i < data.items.length; i++){
  //       if (data.items[i].id == id){
  //         var itemData = data.items[i];
  //         break;
  //       }
  //     }
  //     // var expectedShipDate = itemData.properties != null ? itemData.properties['EXPECTED SHIP DATE'] != null ? itemData.properties['EXPECTED SHIP DATE'] : '' : '';
  //     // var size = itemData.variant_options.length > 1 ? itemData.variant_options[1].trim() : '';
  //     // window.dataLayer = window.dataLayer || [];
  //     // window.dataLayer.push({
  //     //   event: 'addToCart',
  //     //   addToCartLocation: 'Mini-Cart',
  //     //   product: {
  //     //     id: itemData.product_id,
  //     //     sku: itemData.variant_id,
  //     //     style: itemData.sku,
  //     //     name: itemData.title,
  //     //     price: (parseInt(itemData.final_price)/100).toFixed(2),
  //     //     basePrice: (parseInt(itemData.original_price)/100).toFixed(2),
  //     //     quantity: itemData.quantity,
  //     //     brand: itemData.vendor,			
  //     //     color: itemData.variant_options[0].trim(),
  //     //     colorFamily: itemData.variant_options[0].trim(),
  //     //     size: size,
  //     //     expectedShipDate: expectedShipDate
  //     //   },
  //     //   productRaw: JSON.parse($('#product_json-'+id).html())
  //     // });
  //     setTimeout(function() {
  //       updateCartEvent(item[0], event, 1)
  //     }, 1000);
  //     //       $('#crt').removeClass('loading');
  //     //       $this.parents('.quick-cart-item').removeClass('loading');
  //   });

  // });
  // $("#crt").on('click', "a.remove_item", function(r){
  //   var $this =$(this);
  //   $this.parents('.quick-cart-item').addClass('loading');
  //   r.preventDefault();
  //   var updateData = {};
  //   var id = $(this).attr('data-id');
  //   var data_bundle_id = $(this).closest('.cart_custom_row').attr('data-bundle-id');
  //   if(data_bundle_id != ''){
  //     $('.quick-cart-item[data-bundle-id="'+ data_bundle_id +'"]').each(function(ii,vv){
  //       updateData[$(vv).attr('data-cart-item-key')] = 0;
  //     });
  //   }else{
  //     updateData[$(this).attr('data-cart-item-key')] = 0;
  //   }
  //   var item = [];
  //   $.getJSON('/cart.js', function(cart) {
  //     var c = $(cart.items).filter(function(index, cont) {                    
  //       return cont.id == id;
  //     });
  //     item.push(c[0]);
  //   });
  //   setTimeout(function(){
  //     $.ajax({
  //       type: 'POST',
  //       url: '/cart/update.js',
  //       data: {
  //         updates: updateData
  //       },
  //       dataType: 'json',
  //       async:false,
  //       success: function(data) {
  //         addToCartSuccess();
  //         $.getJSON("/cart.js", function(cart) {
  //           refreshCart(cart);
  //           freeGift(cart);
  //         });
  //         setTimeout(function() {
  //           updateCartEvent(item[0], 'remove')
  //         }, 1000);
  //       },
  //       error: function (jqXHR, textStatus, errorThrown) {
  //         var response = $.parseJSON(jqXHR.responseText);
  //         alert(response.description);
  //         $this.parents('.quick-cart-item').removeClass('loading');
  //       }
  //     });
  //   },100);
  // });

  // $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
  //   e.preventDefault();
  //   $('body').removeClass('menuOpen');
  //   $('.fullPage').removeClass('witmenu');
  //   $('body').removeClass('cartOpen');
  // });
  // $('.cart_button').on('click',function(e){
  //   // e.preventDefault();
  //   // setTimeout(function(){
  //   //   addToCartSuccess();
  //   //   $('body').addClass('cartOpen');
  //   //   $('.fullPage').addClass('witmenu');
  //   // }, 50);
  // });

  /* homeproduct tab*/ 
  $('a.s8-product-pcs-btn.w-button').click(function(e){
    e.preventDefault();
    $('.s8-filtry-div-desktop .w-col.w-col-4.w-col-stack').removeClass('active');
    var pro=$(this).attr('href');
    $('.s8-filtry-div-desktop '+pro).addClass('active');
    if($('.slider-for').hasClass('slick-initialized')) {
      $('.slider-for').slick('refresh');
    } else {
      $('.slider-for').slick();
    }
    if($('.slider-nav').hasClass('slick-initialized')) {
      $('.slider-nav').slick('refresh');
    } else {
      $('.slider-nav').slick();
    }

  });


  /*------------------ Collection filter -------------*/
  var data_collectionFilter = '[data-collectionFilter]';
  var data_collection_price_filter = '[data-collection-price-filter]';
  var data_collection_activepriceFilter = '[data-collection-activepriceFilter]';
  var data_collectionWPgrid = '[data-collectionWPgrid]';
  var data_collectionSortby = '[data-collectionSortby]';
  var data_total_result ='[data-total-result]';
  var data_total_result_mob ='[data-total-result-mob]';
  var data_filter_clear = '[data-filter-clear]'

  function returnRefinedURL (key, url) {
    var urlParts = url.split('?');
    if (urlParts.length === 1 || url.indexOf(key) === -1 ) {
      return url;
    }else {
      var keyValues = urlParts[1].split('&'),
          refinedKeyValues = keyValues.filter(function (keyValuePair) {
            return keyValuePair.indexOf(key) !== 0;
          }).join('&');
    }
    if(refinedKeyValues == ''){
      return urlParts[0]; 
    }else{
      return urlParts[0] + '?' + refinedKeyValues; 
    }        
  }
  function getd(currentURL){
    $.get(currentURL, function( data ) {     
      // console.log('**** ' + currentURL);     
      window.history.replaceState(null, null, currentURL);          
      var newchtml = $(data).find('#filterList .filter-select').each(function(i,v){              
        $('#filterList .filter-select:eq('+i+')').html($(this).html());
      });                     
      $('body').find('.current_filter').html($(data).find('.current_filter').html());
      $('body').find('.cm-sort-filter').html($(data).find('.cm-sort-filter').html());
      $('body').find(data_collectionWPgrid).html($(data).find(data_collectionWPgrid).html());
      $('body').find(data_total_result).html($(data).find(data_total_result).html());
      $('body').find(data_total_result_mob).html($(data).find(data_total_result_mob).html());
      $('body').removeClass('has_loader');
    });
  }
  var typingTimer;                //timer identifier
  var doneTypingInterval = 1500;  //time in ms, 5 second for example
  $('body').on('keydown',data_collection_price_filter,function(e){  
    var max = parseInt($(this).attr('max'));
    var val = $(this).val();
    var charCode = (e.which) ? e.which : e.keyCode;
    $('.outerr').remove();
    if ((charCode > 8 && charCode < 20) ) {          
      e.preventDefault();          
      return false;
    } 
    clearTimeout(typingTimer);
  });

  $('body').on('keyup',data_collection_price_filter,function(e){
    var max = parseInt($(this).attr('max'));
    var _this = $(this);
    var href = _this.data('href');
    var val = _this.val();        
    var charCode = (e.which) ? e.which : e.keyCode;        
    $('.outerr').remove();
    if ((charCode > 8 && charCode < 20)) {
      e.preventDefault();          
      return false;          
    }                
    if(parseInt(val) > max){
      $(this).parent().after('<p class="outerr" style="color: red;">Please add below the number of max price.</p>');
      e.preventDefault();          
      return false;
    }
    typingTimer = setTimeout(function(){
      $('body').addClass('has_loader');
      if(val != undefined && val != ''){          
        if(val.indexOf(' ') >= 0){
          val = val.replace(' ','+');
        }
        var finalVAL = href+'='+val;     
        var currentURL = window.location.href;
        currentURL = returnRefinedURL (encodeURI(href), currentURL);
        if(currentURL.indexOf('?') >= 0){
          currentURL = currentURL + '&' + finalVAL;
        }else{
          currentURL = currentURL + '?' + finalVAL;
        } 
        getd(currentURL);                     
      }else{
        var currentURL = window.location.href;
        currentURL = returnRefinedURL (encodeURI(href), currentURL);
        getd(currentURL);
      }
    }, doneTypingInterval);         
  });

  $('body').on('click',data_collection_activepriceFilter,function(){
    var currentURL = window.location.href;
    var prarr = ['filter.v.price.gte','filter.v.price.lte'];
    for(var i=0;i<2;i++){
      if(currentURL.indexOf(prarr[i]) >= 0){
        currentURL = returnRefinedURL (encodeURI(prarr[i]), currentURL);
      }
    }
    getd(currentURL);
  });

  $('body').on('change',data_collectionSortby,function(e){
    e.preventDefault();
    // console.log($(this).parents('.Sort-collection').attr('class'));
    $('body').addClass('has_loader');
    if($(this).parents('.Sort-collection').hasClass('sort_by_mob')){
      var Oval = $(this).data('value');
      var sval = 'sort_by='+$(this).data('value');
    }else{
      var Oval = $(this).val();
      var sval = 'sort_by='+$(this).val();
    }
    var currentSURL = window.location.href; 
    if(currentSURL.indexOf('sort_by=') >= 0){
      if(currentSURL.indexOf(sval) >= 0){
        currentSURL = returnRefinedURL (sval, currentSURL);
      }else{            
        var href = new URL(currentSURL);   
        href.searchParams.set('sort_by', Oval); 
        currentSURL = href.toString();            
      }
    }else{
      if(currentSURL.indexOf('?') >= 0){
        currentSURL = currentSURL + '&' + sval;
      }else{
        currentSURL = currentSURL + '?' + sval;
      } 
    }                  
    getd(currentSURL);
  });

  $('body').on('click',data_collectionFilter,function(e){
    e.preventDefault();
    $('body').addClass('has_loader');
    var href = $(this).data('href');
    var val = $(this).attr('value');
    if(val != undefined && val != ''){
      if(val.indexOf(' ') >= 0){
        val = val.replaceAll(' ','+');
      }
      var currentURL = window.location.href;
      var finalVAL = href+'='+val;
      var is_current = false;
      var without_cur = [];
      var params = {};
      var parser = document.createElement('a');
      parser.href = window.location.href;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if(encodeURI(href) == pair[0] && val == pair[1]){
          is_current = true;
        }else{
          without_cur.push(pair[0] + '=' + pair[1]);
        }
      }
      if(is_current){            
        currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
        if(without_cur.length > 0){
          currentURL = currentURL + '?' +without_cur.join('&')
        }else{              
          currentURL = currentURL;
        }            
      }else{
        if(currentURL.indexOf('?') >= 0){
          currentURL = currentURL + '&' + finalVAL;
        }else{
          currentURL = currentURL + '?' + finalVAL;
        } 
      }         
      getd(currentURL);          
    }
  });
  $('body').on('click',data_filter_clear,function(e){
    e.preventDefault();
    var currentURL = window.location.href;
    if(currentURL.indexOf('?') >= 0){
      var new_url = currentURL.split('?');
      getd(new_url[0]);
    }
    $('.coll_filter, body').removeClass('avtive_mob_filter');
  });
  
  $('body').on('click','[data-collection-variant-detail] .color-id',function(){
    console.log('9999999999')
    var getOptionData = JSON.parse($(this).parent('li').find('.product_option[type="application/json"]').text());
    if ($(this).parent('li').find('.product_collection_json[type="application/json"]').length > 0) {
      var getProductColData = JSON.parse($(this).parent('li').find('.product_collection_json[type="application/json"]').text());
    }
    var getProductData = JSON.parse($(this).parent('li').find('.product_json[type="application/json"]').text());
    var getMetaData = JSON.parse($(this).parent('li').find('.product_meta[type="application/json"]').text());
    var input_id= $(this).attr('input-id');
    var html='', availablility,tag,badge='',first=true;
    var $this = $(this);

    set_collection_img(getProductData,$this.parents('.product-card'));
    //     $this.parents('.product-card').find('.product-img img').attr('src',getProductData.featured_image);
    var title_split = (getProductData.title).split('-');
    var title = title_split[0].replace('The','');
    var color_name= title_split[title_split.length-1];
    $(getProductData.tags).each(function(tagi,tagv){
      if(tagv.indexOf('gender:') > -1){
        tag = tagv.replace('gender:','');
      }else if(tagv.indexOf('badge:') > -1) {
        badge = badge + ' ' + tagv.replace('badge:','');
      }
    });
    if(tag != undefined){
      if((tag.indexOf('Unisex') > -1)||(tag.indexOf('unisex') > -1)){
        var add_s = " ";
      }else{
        var add_s = "'s ";
      }
      var titletag = tag.charAt(0).toUpperCase()+ tag.slice(1).toLowerCase()+ add_s +title;
    }else{
      var titletag = title_split[0];
    }

    if (typeof getProductData != 'undefined') {
      var promo = $(getProductData.tags).filter(function(index, cont) {
        return cont == 'CYBER2023';
      });
    }
    if (typeof getProductData != 'undefined') {
      var hide_size = $(getProductData.tags).filter(function(index, hide_quick) {
        return hide_quick == 'HIDEATC';
      });
    }
    // if (typeof getProductData != 'undefined') {
    //   var promo = $(getProductData.tags).filter(function(index, cont) {
    //     return cont == 'FFS25';
    //   });
    // }
     if (typeof getProductData != 'undefined') {
      var imag_tag = $(getProductData.tags).filter(function(index, cont) {
      return cont == '3D-IMAGE';
      });
     }
    if(hide_size.length > 0 ){
      $this.parents('.product-card').find('.quick-wapper').hide();
    }else{
      $this.parents('.product-card').find('.quick-wapper').show();
    }
    $this.parents('.product-card').find('.pc-name-price .pc-name').text(titletag);
    $this.parents('.product-card').find('.pc-color-count i').text(color_name);
    $this.parents('.product-card').find('.pc-name-price .pc-name').attr('href','/products/'+getProductData.handle);
    
    $this.parents('.product-card').attr('data-product-handle',getProductData.handle);
    
    if((badge != '')&&(badge != undefined)){
      $this.parents('.product-card').find('.pc-label').addClass('has_bagde').text(badge);
    }else{
      $this.parents('.product-card').find('.pc-label').removeClass('has_bagde').text('');
    }

    // console.log( getProductData);
    $.each(getProductData.variants, function (i, variant){
      var preorder_content= '',preorder_cart_content='';
      var metafiled_id_pro= variant.id+'_pdp_msg';
      var metafiled_id_cart= variant.id+'_cart_msg';
      
      if(variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0){
        availablility = "preorder";
      } else if(variant.available){
        availablility = "available";
      }else{
        availablility = "soldout";
      }
      preorder_content = getMetaData[metafiled_id_pro];
      preorder_cart_content = getMetaData[metafiled_id_cart];
      if(first){
        if (typeof promo != 'undefined') {
          if (promo.length > 0) {
            $this.parents('.product-card').find('.promo-message').remove();
            // var price = formatMoney(Math.ceil((variant.price - ((variant.price*35)/100)) * 100)/100, moneyFormat).replaceAll('"','');
            // $this.parents('.product-card').find('.q-add-label').after('<div class="promo-message">'+price+' with code CYBER</div>');
          } else {
            $this.parents('.product-card').find('.promo-message').remove();
          }
          
        }
         if (typeof imag_tag != 'undefined') {
          if (imag_tag.length > 0) {
            $this.parents('.product-card').find('.img-label').show();
          } else {
            $this.parents('.product-card').find('.img-label').hide();
          }
          
        }
        if(variant.compare_at_price > variant.price){
          $this.parents('.pc-detail').find('.pc-price-wp').addClass('has_compare_price');
          $this.parents('.pc-detail').find('.pc-price-wp [data_main_price]').text((formatMoney(variant.price, moneyFormat)).replaceAll('"',''));
          $this.parents('.pc-detail').find('.pc-price-wp [data_compare_price]').text((formatMoney(variant.compare_at_price, moneyFormat)).replaceAll('"','')).show();
        }else{
          $this.parents('.pc-detail').find('.pc-price-wp').removeClass('has_compare_price');
          $this.parents('.pc-detail').find('.pc-price-wp [data_main_price]').text((formatMoney(variant.price, moneyFormat)).replaceAll('"',''));
          $this.parents('.pc-detail').find('.pc-price-wp [data_compare_price]').text('').hide();
        }
        first = false;
      }

      $.each(variant.options, function (index, option){ 
        $.each(getOptionData, function (j, k){ 
          if (k == option) {
            html+='<li class="swatch-element '+option.replaceAll(/['"″"]+/g, '')+' '+ availablility +'" data-preorder-cart="'+ preorder_cart_content +'">';
            html+='<input type="radio" data-product-id="'+ getProductData.id +'" data-var-id="'+ variant.id +'" name="Size-'+input_id+'" value="'+option+'" id="'+input_id+'-'+j+'" data-main-price="'+variant.price+'" data-compare-price="'+variant.compare_at_price+'"><label for="'+input_id+'-'+j+'">'+ option;
            if(availablility == 'soldout'){
              html+='<img class="crossed-out" src="//cdn.shopify.com/s/files/1/0238/2821/t/501/assets/sold_out.png?v=15666490684479693565">';
              html+='<div class="notify-me">';
              html+='<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">';
              html+='<path d="M10.5 5.25C10.5 6.43322 10.5 9.75 10.5 9.75H6H1.59567C1.59567 9.75 1.5 6.70825 1.5 5.25C1.5 2.76472 3.51472 0.75 6 0.75C8.48528 0.75 10.5 2.76472 10.5 5.25Z" stroke="white" stroke-width="1.2"/>';
              html+='<line x1="0.6" y1="9.75599" x2="11.4" y2="9.75599" stroke="white" stroke-width="1.2" stroke-linecap="round"/>';
              html+='<path d="M7.5 9.75019C7.5 10.5786 6.82843 11.2502 6 11.2502C5.17157 11.2502 4.5 10.5786 4.5 9.75019C5.25 9.75 6 9.75 6 9.75C6 9.75 6.75 9.75 7.5 9.75019Z" stroke="white" stroke-width="1.2"/>';
              html+='</svg>';
              html+='</div>';
            }
            html+='</label></li>';
          }
        });
      });
    });
    var ccc = $this.attr('data-color');	    
    $this.parents('.pc-detail').find('.pdp-select-size ul').html(html);
    $this.parents('.pc-color-box').find('.color-box').removeClass('current_active_color');
    $this.parents('li').addClass('current_active_color');
    if ($this.parents('.product-card').find('.selected-color').length) {	
      $this.parents('.product-card').find('.selected-color').text(ccc);	
    }
    if($this.parents('.product-card').hasClass('bundle-product-card')){
      var bundle_price=0;

      $this.parents('.product_add_sec').find('.Bundle_Product_swatch input[type="radio"]:checked').each(function(){
        bundle_price+=parseInt($(this).attr('data-main-price'));
      });
    }
    return false;
  });

  /*   Product Variant change */
  $('body').on('change','.product-template-swatch input[type="radio"]',function(e){
    var $this = $(this);
    var id = $this.attr('data-var-id');
    var mprice = parseInt($this.attr('data-main-price'));
    var cprice = parseInt($this.attr('data-compare-price'));
    var inventory = $this.attr('data-inventory');
    var product_id = $this.attr('data-product-id');
    var selected_available = 'soldout';
    if($this.parents('li').hasClass('available')){
      selected_available = 'available';
    }else if($this.parents('li').hasClass('preorder')){
      selected_available = 'preorder';
    }
    console.log(selected_available,'selected_available');
    if(cprice > mprice){
      $this.parents('.pdp-detail-list').find('.pdp-detail-price').addClass('has_compare');
      $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_main_price]').text((formatMoney(mprice, moneyFormat)).replaceAll('"',''));
      $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_compare_price]').text((formatMoney(cprice, moneyFormat)).replaceAll('"','')).show();
      $('#StickyATC').find('.product-price-wrapper [data_main_price]').text((formatMoney(mprice, moneyFormat)).replaceAll('"',''));
      $('#StickyATC').find('.product-price-wrapper [data_compare_price]').text((formatMoney(cprice, moneyFormat).replaceAll('"',''))).show();
      $('#StickyATC').find('.product-price-wrapper [data_main_price]').addClass('sale-price');
    }else{
      $this.parents('.pdp-detail-list').find('.pdp-detail-price').removeClass('has_compare');
      $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_main_price]').text((formatMoney(mprice, moneyFormat)).replaceAll('"',''));
      $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_compare_price]').text('').hide();
      $('#StickyATC').find('.product-price-wrapper [data_main_price]').text((formatMoney(mprice, moneyFormat)).replaceAll('"',''));
      $('#StickyATC').find('.product-price-wrapper [data_compare_price]').text('').hide();
      $('#StickyATC').find('.product-price-wrapper [data_main_price]').removeClass('sale-price');
    }
    
    // Check Low Inventory Warning
    const low_inventory_threshold = Number($this.parents('.pdp-detail-list').find('.pdp-low-inventory').attr('data-threshold'));
    if (inventory <= low_inventory_threshold && inventory > 0) {
      $this.parents('.pdp-detail-list').find('.pdp-low-inventory').text(`Only ${inventory} left in stock`).show();
    } else {
      $this.parents('.pdp-detail-list').find('.pdp-low-inventory').hide();
    }

    var afterpay_price = mprice/4;
    $this.parents('.pdp-detail-list').find('.pdp-after-pay .afterpay_price').text((formatMoney(afterpay_price, moneyFormat)).replaceAll('"',''));
    //Update Sticky ATC Size
    $('#StickyATC').find('.btn-wrapper .product-size').text($this.val());
    UpdateProductButton($this,selected_available,product_id);
    var current_url=$(this).parents('.pdp-block-detail').attr('data-pro-url');
    var newherf=current_url+'?variant='+id;
    window.history.replaceState(null, null, newherf); 

  });


  // $('body').on('click','[data-product-template] .color-id',function(){
  //   var getOptionData = JSON.parse($(this).parents('li').find('.product_option[type="application/json"]').text());
  //   var getProductData = JSON.parse($(this).parents('li').find('.product_json[type="application/json"]').text());
  //   var getProductColData = JSON.parse($(this).parent('li').find('.product_collection_json[type="application/json"]').text());
  //   var getMetaData = JSON.parse($(this).parents('li').find('.product_meta[type="application/json"]').text());
    
  //   var current_url=$(this).attr('data-pro-url');
  //   var color_name = $(this).attr('data-color');
  //   var $this = $(this),product_id =getProductData.id;
  //   var current_val = $this.parents('.pdp-detail-list').find('.product-template-swatch input[type="radio"]:checked').val();
  //   var html='',first=true,availablility,badge='',tag,selected_available,selected_attr,checked=false,current_url,newherf='';
  //   var selected_color_url = '';
  //   $(getProductData.tags).each(function(tagi,tagv){
  //     if(tagv.indexOf('gender:') > -1){
  //       tag = tagv.replace('gender:','');
  //     }else if(tagv.indexOf('badge:') > -1) {
  //       badge = badge + ' ' + tagv.replace('badge:','');
  //     }
  //   });
  //   var promo = $(getProductData.tags).filter(function(index, cont) {
  //     return cont == 'CYBER2023';
  //   });
  //   if (typeof getProductData != 'undefined') {
  //     var hide_size = $(getProductData.tags).filter(function(index, hide_quick) {
  //       return hide_quick == 'HIDEATC';
  //     });
  //   }
  //   if (hide_size.length > 0) {
  //     $('.pdp-size-sub').show();
  //     $('.swatch-product-wapper').hide();
  //   }else{
  //     $('.pdp-size-sub').hide();
  //     $('.swatch-product-wapper').show();
  //   }
  //   // var promo = $(getProductData.tags).filter(function(index, cont) {
  //   //   return cont == 'FFS25';
  //   // });
  //   $('.pdp-head-desk , .pdp-head-mb').find('.pdp-detail-head h1').text(getProductData.title);
  //   $('#StickyATC').find('.product-info .product-title').text(getProductData.title);
  //   selected_color_url = $this.attr('style').match(/url\(['"]?(.*?)['"]?\)/)[1];
  //   const selected_color_html = `<img src="${selected_color_url}" onerror="this.style.display='none'" />`;
  //   $('#StickyATC').find('.btn-wrapper .color-swatch-wrapper .color-swatch').html(selected_color_html);
  //   $this.parents('.product-list-color-swatch').find('li').removeClass('current_active_color');
  //   $this.parents('li').addClass('current_active_color');
  //   $.each(getProductData.variants, function (i, variant){
  //     var preorder = '';
  //     var preorder_content= '',preorder_cart_content='';
  //     var metafiled_id_pro= variant.id+'_pdp_msg';
  //     var metafiled_id_cart= variant.id+'_cart_msg';
  //     if(variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0){
  //       availablility='preorder';
  //     }else if(variant.available){
  //       availablility = "available";
  //     }else{
  //       availablility = "soldout";
  //     }
  //     preorder_content = getMetaData[metafiled_id_pro];
  //     preorder_cart_content = getMetaData[metafiled_id_cart];
  //     if(first){
  //       if (promo.length > 0) {
  //         $this.parents('.pdp-detail-list').find('.promo-message').remove();
  //         // $this.parents('.pdp-detail-list').find('.pdp-detail-price').removeClass('flash-sale');
  //         // var price = formatMoney(Math.ceil((variant.price - ((variant.price*35)/100)) * 100)/100, moneyFormat).replaceAll('"','');
  //         // $this.parents('.pdp-detail-list').find('.pdp-detail-price').append('<div class="promo-message">'+price+' with code CYBER</div>');
  //         // $this.parents('.pdp-detail-list').find('.pdp-detail-price').addClass('flash-sale');
  //         } else {
  //         $this.parents('.pdp-detail-list').find('.promo-message').remove();
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price').removeClass('flash-sale');
  //       }
  //       const stickyHeader = document.querySelector('#StickyATC');
  //       if(variant.compare_at_price > variant.price) {
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price').addClass('has_compare');
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_main_price]').text((formatMoney(variant.price, moneyFormat)).replaceAll('"',''));
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_compare_price]').text((formatMoney(variant.compare_at_price, moneyFormat)).replaceAll('"','')).show();
  //         $('#StickyATC').find('.product-price-wrapper [data_main_price]').text((formatMoney(variant.price, moneyFormat)).replaceAll('"',''));
  //         $('#StickyATC').find('.product-price-wrapper [data_compare_price]').text((formatMoney(variant.compare_at_price, moneyFormat).replaceAll('"',''))).show();
  //         $('#StickyATC').find('.product-price-wrapper [data_main_price]').addClass('sale-price');
  //         // stickyHeader.querySelector('.product-price-wrapper [data_main_price]').textContent = formatMoney(variant.price, moneyFormat).replaceAll('"','');
  //         // stickyHeader.querySelector('.product-price-wrapper [data_compare_price]').textContent = formatMoney(variant.compare_at_price, moneyFormat).replaceAll('"','');
  //         // stickyHeader.querySelector('.product-price-wrapper [data_compare_price]').style.display = 'block';
  //       }else{
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price').removeClass('has_compare');
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_main_price]').text((formatMoney(variant.price, moneyFormat)).replaceAll('"',''));
  //         $this.parents('.pdp-detail-list').find('.pdp-detail-price [data_compare_price]').text('').hide();
  //         $('#StickyATC').find('.product-price-wrapper [data_main_price]').text((formatMoney(variant.price, moneyFormat)).replaceAll('"',''));
  //         $('#StickyATC').find('.product-price-wrapper [data_compare_price]').text('').hide();
  //         $('#StickyATC').find('.product-price-wrapper [data_main_price]').removeClass('sale-price');
  //         // stickyHeader.querySelector('.product-price-wrapper [data_main_price]').textContent = formatMoney(variant.price, moneyFormat).replaceAll('"','');
  //         // stickyHeader.querySelector('.product-price-wrapper [data_compare_price]').textContent = '';
  //         // stickyHeader.querySelector('.product-price-wrapper [data_compare_price]').style.display = 'none';
  //       }

  //       if(getProductData.tags.includes('FinalSale')) {
  //         $this.parents('.pdp-detail-list').find('.fs-warning').show();
  //       } else {
  //         $this.parents('.pdp-detail-list').find('.fs-warning').hide();
  //       }

  //       var afterpay_price = variant.price/4;
  //       $this.parents('.pdp-detail-list').find('.pdp-after-pay .afterpay_price').text((formatMoney(afterpay_price, moneyFormat)).replaceAll('"',''));
  //       first = false;
  //     }

  //     $.each(variant.options, function (index, option){ 
  //       $.each(getOptionData, function (j, k){
  //         if (k == option) {
  //           var option_value = option.replaceAll('"', '&quot;');
  //           if(current_val != undefined){
  //             if(k==current_val){
  //               selected_attr = 'checked';
  //               selected_available = availablility;
  //               checked = true;
  //               newherf=current_url+'?variant='+variant.id;
  //             }else{
  //               selected_attr = '';
  //             }

  //           }
  //           html+='<li class="swatch-element'+option.replaceAll(/['"″"]+/g, '')+' '+ availablility +'" data-preorder-info="'+preorder_content+'" data-preorder-cart="'+ preorder_cart_content +'">';
  //           html+='<input type="radio" data-product-id="'+ getProductData.id +'" data-var-id="'+ variant.id +'"  name="Size-'+getProductData.id+'" value="'+option_value+'" id="'+getProductData.id+'-'+variant.id+'-'+j+'" data-main-price="'+variant.price+'" data-compare-price="'+variant.compare_at_price+'" data-inventory="'+variant.inventory_quantity+'" '+ selected_attr +'><label for="'+getProductData.id+'-'+variant.id+'-'+j+'">'+ option;
  //           if(availablility == 'soldout'){
  //             html+='<img class="crossed-out" src="//cdn.shopify.com/s/files/1/0238/2821/files/sold_out.png?v=1739812000">';
  //             html+='<div class="notify-me">';
  //             html+='<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">';
  //             html+='<path d="M10.5 5.25C10.5 6.43322 10.5 9.75 10.5 9.75H6H1.59567C1.59567 9.75 1.5 6.70825 1.5 5.25C1.5 2.76472 3.51472 0.75 6 0.75C8.48528 0.75 10.5 2.76472 10.5 5.25Z" stroke="white" stroke-width="1.2"/>';
  //             html+='<line x1="0.6" y1="9.75599" x2="11.4" y2="9.75599" stroke="white" stroke-width="1.2" stroke-linecap="round"/>';
  //             html+='<path d="M7.5 9.75019C7.5 10.5786 6.82843 11.2502 6 11.2502C5.17157 11.2502 4.5 10.5786 4.5 9.75019C5.25 9.75 6 9.75 6 9.75C6 9.75 6.75 9.75 7.5 9.75019Z" stroke="white" stroke-width="1.2"/>';
  //             html+='</svg>';
  //             html+='</div>';
  //           }
  //           html+='</label></li>';
  //         }
  //       });
  //     });
  //   });
    
  //   var images = getProductData.images;
  //   var imghtml= '';
  //   for(var i=0;i<images.length;i++){
  //     imghtml+='<div class="pdp-img-item large-slide"><a class="MagicZoom" href="'+images[i]+'" data-gallery="group" data-zoom-id="Zoom-1"><img src="'+images[i]+'" alt="" class="js-zoom-enabled"/></a></div>';
  //   }
  //   if($this.parents('.pdp-detail-list').find('.pdp_img_wrap .pdp_img_grid').hasClass('swiper-initialized')){
  //    if($this.parents('.pdp-detail-list').find('.pdp_img_wrap .pdp_img_grid')[0].swiper) {
  //      $this.parents('.pdp-detail-list').find('.pdp_img_wrap .pdp_img_grid')[0].swiper.destroy(true, true);
  //    }
  //    $this.parents('.pdp-detail-list').find('.pdp_img_wrap .pdp_img_grid').removeClass('swiper-initialized');
  //  }
  //   $this.parents('.pdp-detail-list').find('.pdp_img_wrap .pdp_img_grid').html(imghtml);
  //   var pslider = $this.parents('.pdp-detail-list').find('.pdp_img_wrap .pdp_img_grid');
  //   setTimeout(function(){
  //     product_slider(pslider);
  //   },1000);

  //   // $this.parents('.pdp-detail-list').find('.pdp_img_wrap .pc-label').text(badge);
  //   // if((badge != '')&&(badge != undefined)){
  //   //   $this.parents('.pdp-detail-list').find('.pc-label').addClass('has_bagde').text(badge);
  //   // }else{
  //   //   $this.parents('.pdp-detail-list').find('.pc-label').removeClass('has_bagde').text('');
  //   // }

  //  $this.parents('.pdp-detail-list').find('.yotpo-reviews-carousel').empty().attr('data-product-id',getProductData.id);
  //   $this.parents('.pdp-detail-list').find('.product-instagram-section').hide();
  //   $.get( '/products/'+ getProductData.handle +'?view=alternate', function( data ) {
  //     $this.parents('.pdp-detail-list').find('.product-instagram-section .yotpo-insta-outer').html($(data).find('.product-instagram-section .yotpo-insta-outer').html());
  //     $this.parents('.pdp-detail-list').find('.review-sec').html($(data).find('.review-sec').html());
  //     $this.parents('.pdp-detail-list').find('.pdp-descr-inner').html($(data).find('.pdp-descr-inner').html());

  //     $this.parents('.pdp-detail-list').find('.breadcrumg-inner').html($(data).find('.pdp-head-desk .breadcrumg-inner').html());
  //     $this.parents('.template--product').find('.yotpo__container.loading').html($(data).find('.yotpo__container.loading').html());
  //     $this.parents('.template--product').find('.product-recommendations-main').html($(data).find('.product-recommendations-main').html());
  //   });
  //   setTimeout(function(){
  //     refreshZoom();
  //     var api = new Yotpo.API(yotpo);
  //     api.refreshWidgets();
  //   },1000);
  //   setTimeout(function(){
  //     var instahtml = $this.parents('.pdp-detail-list').find('.product-instagram-section .yotpo-pictures-widget').html();
  //     var instacount = parseInt($this.parents('.pdp-detail-list').find('.product-instagram-section .yotpo-slider').attr('data-images'));
  //     if((instahtml != '')&&(instahtml != ' ')&&(instacount >= 3)){
  //       $this.parents('.pdp-detail-list').find('.product-instagram-section').show();
  //     }else{
  //       $this.parents('.pdp-detail-list').find('.product-instagram-section').hide();
  //     }
  //   },5000);

  //   $this.parents('.pdp-detail-list').find('.pdp-variant span.color_name').text(color_name);
  //   //$this.parents('.pdp-detail-list').find('.pdp-descr-inner').html(getProductData.description);
  //   $this.parents('.pdp-detail-list').find('ul.product-template-swatch').html(html);
  //   if((current_val != undefined)&&(current_val != '')){
  //     if(selected_available == undefined) {
  //       $('#StickyATC').find('.btn-wrapper .product-size').text('Size');
  //     }
  //     UpdateProductButton($this,selected_available,product_id);

  //     // Check Low Inventory Warning
  //     const current_inventory = $this.parents('.pdp-detail-list').find('.product-template-swatch input[type="radio"]:checked').attr('data-inventory');
  //     const low_inventory_threshold = Number($this.parents('.pdp-detail-list').find('.pdp-low-inventory').attr('data-threshold'));
  //     if (current_inventory <= low_inventory_threshold && current_inventory > 0) {
  //       $this.parents('.pdp-detail-list').find('.pdp-low-inventory').text(`Only ${current_inventory} left in stock`).show();
  //     } else {
  //       $this.parents('.pdp-detail-list').find('.pdp-low-inventory').hide();
  //     }
      
  //   }else{
  //     newherf=current_url;
  //   }
  //   window.history.replaceState(null, null, newherf); 
  // });
  
  jQuery('.f-link-title').click(function() {
    if ($(window).width() < 768) {
      $(this).next().slideToggle('slow', function() {});
      $(this).toggleClass("active");
    }
  });

  // jQuery(".filter_trigger").click(function(e) {
  //   e.preventDefault();
  //   if ($(window).width() < 768) {
  //     $('.coll_filter, body').addClass('avtive_mob_filter');
  //     $(this).toggleClass('btn_active');
  //   } else {
  //     $('.coll_filter').toggleClass('avtive_filter');
  //     $('.Collection_Main_Wrapper ').toggleClass('avtive_filter');
  //     $(this).toggleClass('btn_active');
  //   }
  // });
  // jQuery(".filter_overlay,[data-filter-close]").click(function(e) {
  //   if ($(window).width() < 768) {
  //     $('.coll_filter, body').removeClass('avtive_mob_filter');
  //     $('.filter_trigger').toggleClass('btn_active');
  //   } else {

  //   }
  // });



  // Bind event listener
  $(window).resize(menu);
  $(function() {
    var headerHeight = $('header').height();
    var headerV1 = document.querySelector('#HeaderV1');
    if(headerV1 != null) {
      $(".wrapper").css("margin-top", headerHeight);
    }
  });
  $(".search-box.r-search .search-svg").click(function() {
    $(".search-box.r-search").addClass("open");
    $('.search-box input').focus();
  });

  $(".search-close").click(function() {

    $(".search-box.r-search").removeClass("open");
  });
  $(".r-child-menu a").click(function() {
    $(this).parent(".r-child-menu").addClass("open");
  });
  $(".back-category").click(function() {
    $(".r-child-menu").removeClass("open");
  });

  $(".hamburger").click(function() {
    $(this).toggleClass("is-active");
    $(".responsive-menu").toggleClass("open");
    $('body').toggleClass('Fixed');
  });
  // $(".viewall-btn").click(function(){
  //   $(this).toggleClass("is-active");
  //   $(".coll_grid").toggleClass("is-active");
  // });

  /*accordian js start here*/
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(this).find('i').removeClass("fa-minus").addClass("fa-plus");
    } else {
      //       $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      //       $(".set > a").removeClass("active");
      //       $(".content").slideUp(200);
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(this).addClass("active");

      $(this).siblings(".content").slideDown(200);
      $('.mobile-image-list').slick('refresh');
    }
  });
  /*accordian js end here*/
  /** multipal tabs script start here */
  $('ul.tabs li').click(function() {

    var $this = $(this);
    var $theTab = $(this).attr('id');
    //     console.log($theTab);
    if ($this.hasClass('active')) {
      // do nothing
    } else {
      $this.closest('.tabs_wrapper').find('ul.tabs li, .tabs_container .tab_content').removeClass('active');
      $('.tabs_container .tab_content[data-tab="' + $theTab + '"], ul.tabs li[id="' + $theTab + '"]').addClass('active');
    }
    $('.new-arrval-slider').slick('refresh');
    $('.featured-card-wrapper').slick('refresh');
    getall_collection_grid();
  });
  /* multipal tabs script end here*/
  $('.an-marquee-slider').slick({
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
  
  $('.collection-menu-slider,.featured-card-wrapper').slick({
    dots: false,
    infinite: true,
    speed: 100,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    waitForAnimate: false,
    touchThreshold: 100,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
                 {
                   breakpoint: 768,
                   settings: {
                     slidesToShow: 2,
                     slidesToScroll: 2
                   }
                 },
                 {
                   breakpoint: 540,
                   settings: {
                     slidesToShow: 1,
                     slidesToScroll: 1,
                     arrows: true,
                   }
                 }
                 // You can unslick at a given breakpoint now by adding:
                 // settings: "unslick"
                 // instead of a settings object
                ]
  });
  collectionSlider();
  $('.new-arrval-slider:not(.new-gift-slider)').slick({
    dots: false,
    infinite: false,
    speed: 100,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    waitForAnimate: false,
    touchThreshold: 100,
    prevArrow: $('.n-prev-arrow'),
    nextArrow: $('.n-next-arrow'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  // $(window).on('load resize orientationchange', function () {
  //   $('.new-arrval-slider').slick('refresh');
  //   $('.featured-card-wrapper').slick('refresh');
  // });
  $('body').on('click', '.n-slider-arrow .tab-slick-prev', function() {
    $(this).parents('section').find('.tab_content.active .new-arrval-slider').slick('slickPrev');
  });
  $('body').on('click', '.n-slider-arrow .tab-slick-next', function() {
    $(this).parents('section').find('.tab_content.active .new-arrval-slider').slick('slickNext');
  });

  $(".filter_header").click(function() {
    $(".filter_header").removeClass("active");
    $(".filter_content").slideUp();
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
    }
  })
  //Need to remove before push//
  // function product_slider($pdp_img_grid_slider){
  // if ($(window).width() > 767) {
  //   if ($pdp_img_grid_slider.hasClass('slick-initialized')) {
  //     $pdp_img_grid_slider.slick('unslick');
  //   }
  // }else{
  //  $pdp_img_grid_slider.slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       mobileFirst: true,
  //       infinite: false,
  //       dots: false,
  //       arrows: true,
  //       adaptiveHeight: true
  //     }).on('afterChange', function(event, slick, currentSlide) {
  //       var slideIndex = currentSlide;
  //      if(slideIndex == 1){
  //        if($('.pdp-img-item').find('.pdp_iframe').length >= 1){
  //          $('.pc-label.has_bagde').hide();
  //        }
  //      }else{
  //        $('.pc-label.has_bagde').show();
  //      }
  //     });
  //     }
  // }
  //   $('.pdp_img_grid').each(function() {
  //     var $pdp_img_grid = $(this);
  //     /* Initializes a slick carousel only on mobile screens */
  //     // slick on mobile
  //        product_slider($pdp_img_grid);
  //   });




  // $(window).on('load', function() {
  //   $('.pdp_img_grid').each(function() {
  //     var $pdp_img_grid = $(this);
  //     /* Initializes a slick carousel only on mobile screens */
  //     // slick on mobile
  //     product_image_slider($pdp_img_grid);
  //   });
  // });

//Need to remove before push//

  // $('body').on("change",'.viewall-btn', function() {
  //   var setlocal = true;
  //   var selected_val = $(this).val();

  //   if(selected_val == 'grid_view'){
  //     $(".q-add-label, .q-add").removeClass('active-menu');
  //     //         $(this).removeClass("active-menu");
  //     $(".coll_grid, body").removeClass('active-menu');
  //   }else{
  //     //         $(this).addClass("active-menu");
  //     $(".coll_grid, body").addClass('active-menu');
  //     var scurrentTime = new Date().getTime();
  //   }
  //     $('.product_slider_img').each(function(){
  //       if($(this).hasClass('slick-initialized')){
  //         $(this).slick('refresh');
  //       }
  //     });
  // });

  $('body').on("click",'.product-card .q-add', function() {
    if($(this).closest('.product-card').find('.q-add-label').hasClass('active-menu')){
      $(this).closest('.product-card').find('.q-add-label').removeClass('active-menu');
      $(this).removeClass('active-menu');
    }else{
      $(this).closest('.product-card').find('.q-add-label').removeClass('active-menu');
      $(this).addClass('active-menu');
      $(this).closest('.product-card').find('.q-add-label').addClass('active-menu');
    }
  });
  $('body').on("click",'.cisp-custom-variants .q-add', function() {
    if($(this).closest('.cisp-custom-variants').find('.q-add-label').hasClass('active-menu')){
      $(this).closest('.cisp-custom-variants').find('.q-add-label').removeClass('active-menu');
      $(this).removeClass('active-menu');
    }else{
      $(this).closest('.cisp-custom-variants').find('.q-add-label').removeClass('active-menu');
      $(this).addClass('active-menu');
      $(this).closest('.cisp-custom-variants').find('.q-add-label').addClass('active-menu');
    }
  });

  $(".size-guide").on("click", function(e) {
    e.preventDefault();
    // $('.size-popup-main, body').addClass("active-guide");
  });
  $(".popup-overlay,.size-popup-close").on("click", function(event) {
    event.stopPropagation();
    $('.size-popup-main, body').removeClass("active-guide");
  });
  $(".notify-overlay,.notify-popup-close").on("click", function() {
    $('.collection_notify_popup,body').removeClass("active-notify");
    
    $('.product-card input[type="radio"]').prop('checked',false);
  });
  $(".faq-title").click(function() {
    //         $(".faq-title").removeClass("active");
    //         $(".faq-content").slideUp();
    //         if (!$(this).next().is(":visible")) {
    //             $(this).next().slideDown();
    //             $(this).addClass("active");
    //         }
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });

  $('body').on('click','[klaviyo-bis-btn]',function(e) {
    e.preventDefault();
    var $form = $(this).parents('.form-klaviyo-bis');
    var klaviyoId = $form.attr('data-klaviyo-id'),
        productId = $form.attr('data-product-id'),
        variantId = $form.attr('data-variant-id'),
        email = $form.find('[klaviyo-bis-email]').val();
    function isEmail(email) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }
    if (isEmail(email)) {
      $form.find('[klaviyo-bis-error]').hide();
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2025-01-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      }

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoId}`, options)
        .then(response => {
          if (response.status === 202) {
            $form.find('[klaviyo-bis-success]').show();
            $form.addClass('success');
          } else if (response.status === 400) {
            $form.find('[klaviyo-bis-error]').show();
          }
        })
        .catch(err => {
          $form.find('[klaviyo-bis-error]').show();
          console.log('Back in stock subscription error:', err)
        });

    } else {
      $form.find('[klaviyo-bis-error]').show();
    }
  });

  $('body').on('click', '.remove_item_cart',function(e){
    e.preventDefault();
    var updateData = {};
    var id = $(this).attr('data-id');
    var data_bundle_id = $(this).closest('.cart_custom_row').attr('data-bundle-id');
    if(data_bundle_id != ''){
      $('.cart_custom_row[data-bundle-id="'+ data_bundle_id +'"]').each(function(ii,vv){
        updateData[$(vv).attr('data-cart-item-key')] = 0;
      });
    }else{
      updateData[$(this).attr('data-cart-item-key')] = 0;
    }
    var item = [];
    $.getJSON('/cart.js', function(cart) {
      var c = $(cart.items).filter(function(index, cont) {                    
        return cont.id == id;
      });
      item.push(c[0]);
    });
    setTimeout(function(){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: updateData
        },
        dataType: 'json',
        async:false,
        success: function(data) {
          $.get( "/cart?view=alternate", function( data ) {
            $('#crt').html(data);
          });
          $.getJSON('/cart.js', function(cart){
            $('.cart_count').text(cart.item_count);
            freeGift(cart, page = true);
          });
          setTimeout(function() {
            updateCartEvent(item[0], 'remove')
          }, 1000);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
        }
      });
    },100);
  });
  
  $('body').on('click', '.main-cart .adjust-cart',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    var event = '';
    if($(this).hasClass('btn-plus')) {
      ip = ip + 1;
      event = 'add';
    } else {
      ip = ip - 1;
      event = 'remove';
    }
    input.val(ip);

    var id = parseInt(input.attr('data-id'));
    var item = [];
    $.getJSON('/cart.js', function(cart) {
      var c = $(cart.items).filter(function(index, cont) {                    
        return cont.id == id;
      });
      item.push(c[0]);
    });
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function(data){
        $.get( "/cart?view=alternate", function( data ) {
          $('#crt').html(data);
        });
        $.getJSON('/cart.js', function(cart){
          $('.cart_count').text(cart.item_count);
          freeGift(cart, page = true);
        });
        for (var i = 0 ; i < data.items.length; i++){
          if (data.items[i].id == id){
            var itemData = data.items[i];
            break;
          }
        }
        // var expectedShipDate = itemData.properties != null ? itemData.properties['EXPECTED SHIP DATE'] != null ? itemData.properties['EXPECTED SHIP DATE'] : '' : '';
        // var size = itemData.variant_options.length > 1 ? itemData.variant_options[1].trim() : '';
        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({
        //   event: 'addToCart',
        //   addToCartLocation: 'Cart Page',
        //   product: {
        //     id: itemData.product_id,
        //     sku: itemData.variant_id,
        //     style: itemData.sku,
        //     name: itemData.title,
        //     price: (parseInt(itemData.final_price)/100).toFixed(2),
        //     basePrice: (parseInt(itemData.original_price)/100).toFixed(2),
        //     quantity: itemData.quantity,
        //     brand: itemData.vendor,			
        //     color: itemData.variant_options[0].trim(),
        //     colorFamily: itemData.variant_options[0].trim(),
        //     size: size,
        //     expectedShipDate: expectedShipDate
        //   },
        //   productRaw: JSON.parse($('#product_json-'+id).html())
        // });
        setTimeout(function() {
          updateCartEvent(item[0], event, 1)
        }, 1000);
      }
    });
  });
  //   $(".menu-wrapper ul li").hover(function () {
  //     $(this).toggleClass("active");
  //   });

  $('body').on('click', '.tag-filter-blog li a',function(e){
    e.preventDefault();
    var href = $(this).attr('href');
    blogtag_grid(href);
  });
  $('body').on('change', '.tag-filter-blog-dropdown',function(e){
    e.preventDefault();
    var href = $(this).find('option:checked').attr('data-val');
    blogtag_grid(href);
  });

  $('.story-descr-wrapper').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  $('body').on('click', '.pdp-detail-list .review-sec',function(e){
    e.preventDefault();
    var href = $(this).attr('data-href');
    $('html,body').animate({scrollTop: $(href).offset().top },'slow');
  });

  $('body').on('click','.scroll-to-options',function(e){
    e.preventDefault();
    if ($(window).width() <= 767) {
      $("html, body").animate({ scrollTop: $('.pdp-block-detail[data-detail-product]').offset().top - 100 });
    } else {
      $("html, body").animate({ scrollTop: $('.pdp-block-detail[data-detail-product]').offset().top - 100 });
    }	
  });

  $("#StickyATC .btn-wrapper .sticky_addtocart").mouseover(function(e){
    if($("#StickyATC .btn-wrapper .product-detail .product-size").text().replace(/\s/g, '') == 'Size'){
      e.preventDefault();
      $("#StickyATC .btn-wrapper .sticky_addtocart [atc_txt]").text('Select A Size');
    }
  });

  $("#StickyATC .btn-wrapper .sticky_addtocart").mouseleave(function(e){
    if($("#StickyATC .btn-wrapper .product-detail .product-size").text().replace(/\s/g, '') == 'Size'){
      e.preventDefault();
      $("#StickyATC .btn-wrapper .sticky_addtocart [atc_txt]").text('Add to Cart');
    }
  });

  // Main ATC hover: show "Select A Size" when no size selected (button disabled)
  $('body').on('mouseenter', '.pdp-submit .Product_add_to_cart[atc_btn]', function(e){
    if($(this).is(':disabled')){
      e.preventDefault();
      $(this).find('[atc_txt]').text('Select A Size');
    }
  });

  $('body').on('mouseleave', '.pdp-submit .Product_add_to_cart[atc_btn]', function(e){
    if($(this).is(':disabled')){
      e.preventDefault();
      $(this).find('[atc_txt]').text('Add to Cart');
    }
  });

  $('body').on('click','.sticky_addtocart',function(e){
    e.preventDefault();
    if($(".trigger_by_sticky[atc_btn]").is(":disabled")){
      if ($('#StickyATC').find('.btn-wrapper [atc_txt]').text().includes('Notify')) {
        const product_id = $('.pa-detail-grid').find('.form-klaviyo-bis').attr('data-product-id');
        const variant_id = $('.pa-detail-grid').find('.form-klaviyo-bis').attr('data-variant-id');
        const pname = $('#StickyATC').find('.product-info .product-title').text();
        var $notify_popup=$('body').find('.collection_notify_popup');
        $notify_popup.addClass('active-notify');
        $notify_popup.find('.Product_name').text(pname);
        $notify_popup.find('.form-klaviyo-bis').attr('data-variant-id',variant_id);
        $notify_popup.find('.form-klaviyo-bis').attr('data-product-id',product_id);
        $('.notify-overlay, body').addClass('active-notify');
      } else {
        $("html, body").animate({ scrollTop: $('.pdp-block-detail[data-detail-product]').offset().top - 100 }, "slow");  
      } 
    }else{
      $('.trigger_by_sticky[atc_btn]').trigger('click');
    }    	
  });
  $('body').on('click','.afterpay-link',function(e){
    e.preventDefault();
    $('body').addClass('after_pop_active');
    $('#afterpay-modal-overlay').show();
  });

  $('body').on('click','#afterpay-modal-close',function(e){
    e.preventDefault();
    $('body').removeClass('after_pop_active');
    $('#afterpay-modal-overlay').hide();
  });

  $(window).resize(function(){
    loadpagefilter();
    // getall_collection_grid();
    if($(".pdp-block-detail[data-detail-product]").length > 0){
      createSticky($(".pdp-block-detail[data-detail-product]"));
    }
  });
  $(window).on('load',function() {
    if($(".pdp-block-detail[data-detail-product]").length > 0){
      createSticky($(".pdp-block-detail[data-detail-product]"));
    }
    getall_collection_grid();
    // setTimeout(function(){
    //   if($('body').find('.pdp-detail-list').length > 0 ){
    //     var instahtml =  $('body').find('.pdp-wrapper').find('.product-instagram-section .yotpo-pictures-widget').html();
    //     var instacount = parseInt($('body').find('.pdp-wrapper').find('.product-instagram-section .yotpo-slider').attr('data-images'));
    //     if((instahtml != '')&&(instahtml != ' ')&&(instacount >= 3)){
    //       $('body').find('.pdp-wrapper').find('.product-instagram-section').show();
    //     }else{
    //       $('body').find('.pdp-wrapper').find('.product-instagram-section').hide();
    //     }
    //   }
    // },5000);
  });
  $(".coll_grid .product-card").hover(function(){
    if(($('.Collection_Main_Wrapper').hasClass('active-menu'))||($('.collection_wrapper').hasClass('mobile_only'))){

    }else{
      $(".q-add-label, body, .q-add").removeClass("active-menu");
    }
  });
  // Collection Page Load More script start (add jquery.ba-dotimeout.min.js in asset)
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  function pInfScrExecute() {
    var elm = document.getElementById('CollectionProductGrid');
      var loadingImage,loadingmore;
      pInfScrNode = $('.load_more_collection').last();
      pInfScrmore = $('.show_more_collection').last();
      pInfScrURL = $('.load_more_collection a').last().attr("href");
      if(!pInfScrLoading && pInfScrNode.length > 0  && pInfScrNode.css('display') != 'none' && pInfScrURL != '') {
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingImage = pInfScrNode.clone().empty().append('<img src="//www.greats.com/cdn/shop/files/load_more.gif?v=2857115307093459456" />');
            loadingImage.insertAfter(pInfScrNode);
            pInfScrNode.hide();
            pInfScrmore.hide();
          },
          success: function(data) {
            pInfScrNode.next().remove();
            pInfScrmore.next().remove();
            var filteredData = $(data).find(".Collection_Main_Wrapper").html();
            $('.Collection_Main_Wrapper').append(filteredData);
            loadingImage.remove();
            pInfScrLoading = false;
            getall_collection_grid();
          },
          dataType: "html"
        });
      }
    
  }
  $('body').on('click', '.show_more_collection',function(){
    if(document.getElementById("CollectionProductGrid")){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      var elm = document.getElementById('CollectionProductGrid');
    }
  });
  // Collection Page Load More script end
  if ($(window).width() <= 767) {
	$('.mobile-image-list').slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
 }

  // Royal API feed product select_item events
  $('body').on('click','[data-section="gift-featured-collection"] .new-product-card a[href]', function(e){
    e.preventDefault();
    
    var pro_h = $(this).parents('.new-product-card').data('product-handle'), href = $(this).attr('href'), index = $(this).parents('.new-product-card').data('product-position');
    const product_info = {
      index: index,
      handle: pro_h,
      listname: "Royal 2.0"
    }
    localStorage.setItem('royal_product',JSON.stringify(product_info));
    window.location = href;
  });
  // Royal API feed product select_item events

   // Product slider function for Swiper
 function product_slider($pdp_img_grid_slider){
   
 
 
 
   // Initialize Swiper for both mobile and desktop with responsive breakpoints
   if (!$pdp_img_grid_slider.hasClass('swiper-initialized')) {
     // Check if Swiper is available
     if (typeof Swiper === 'undefined') {
       console.warn('Swiper not loaded, skipping initialization');
       return;
     }
     
     // Clean up any existing structure
     $pdp_img_grid_slider.find('.swiper-wrapper').children().unwrap();
     $pdp_img_grid_slider.next('.swiper-pagination').remove();
     $pdp_img_grid_slider.next('.swiper-button-next').remove();
     $pdp_img_grid_slider.next('.swiper-button-prev').remove();
     
     // Add Swiper wrapper and pagination
     $pdp_img_grid_slider.addClass('swiper');
     $pdp_img_grid_slider.find('.pdp-img-item').wrapAll('<div class="swiper-wrapper" id="lg-swipper"></div>');
     $pdp_img_grid_slider.find('.pdp-img-item').addClass('swiper-slide');
     
     // Add pagination dots
     $pdp_img_grid_slider.after('<div class="swiper-pagination"></div>');
     
     // Add navigation arrows INSIDE the container
     $pdp_img_grid_slider.append('<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>');
     
     // Initialize Swiper with better configuration
     let $lgSwiper = document.getElementById("lg-swipper");
     const swiper = new Swiper($pdp_img_grid_slider[0], {
       slidesPerView: 1,
       spaceBetween: 0,
       loop: false,
       touchRatio: 1,
       touchAngle: 45,
       grabCursor: false,
       allowTouchMove: true,
       navigation: {
         nextEl: $pdp_img_grid_slider.find('.swiper-button-next')[0],
         prevEl: $pdp_img_grid_slider.find('.swiper-button-prev')[0],
       },
       pagination: {
         el: $pdp_img_grid_slider.next('.swiper-pagination')[0],
         clickable: true,
         dynamicBullets: false,
       },
               // Responsive breakpoints for different screen sizes
      breakpoints: {
        // Mobile (≤767px) - keep current settings
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true
        },
        // Desktop (≥768px) - new settings you wanted
        768: {
          slidesPerView: 1.5,
          spaceBetween: 6,
          allowTouchMove: true// Disable touch on desktop to prevent conflict with MagicZoom
        }
      },
       on: {
         slideChange: function () {
           var slideIndex = this.activeIndex;
           var $prevButton = $pdp_img_grid_slider.find('.swiper-button-prev');
           var $nextButton = $pdp_img_grid_slider.find('.swiper-button-next');
           
           // Show prev button only after going forward (slideIndex > 0)
           if(slideIndex > 0) {
             $prevButton.show();
           } else {
             $prevButton.hide();
           }
           
           // Hide next button when at the last slide
           if(this.isEnd) {
             $nextButton.hide();
           } else {
             $nextButton.show();
           }
           
           if(slideIndex == 1){
             if($('.pdp-img-item').find('.pdp_iframe').length >= 1){
               $('.pc-label.has_bagde').hide();
             }
           } else {
             $('.pc-label.has_bagde').show();
           }
         },
         init: function () {
          const lg = lightGallery($lgSwiper, {
            zoomFromOrigin: false,
            backdropDuration: 100,
            speed: 300,
            fit: 'contain',
            scale: 1,
            zoom: true,
            fullScreen: true,
            download: false,
            actualSize: true,
            getCaptionFromTitleOrAlt: false,
            controls: true,
            mobileSettings: {
              controls: false,
              showCloseIcon: true,
              download: false,
              rotate: false
            }
          });

          $lgSwiper.addEventListener("lgBeforeClose", () => {
            swiper.slideTo(lg.index, 0);
          });
          
           // Initially hide the prev button
           var $prevButton = $pdp_img_grid_slider.find('.swiper-button-prev');
           $prevButton.hide();
           
           // Check if we're at the end initially and hide next button if needed
           var $nextButton = $pdp_img_grid_slider.find('.swiper-button-next');
           if(this.isEnd) {
             $nextButton.hide();
           }
         }
       }
     });
     
     $pdp_img_grid_slider.addClass('swiper-initialized');
   } 


}

// Handle window resize for Swiper slider
$(window).on('resize', function() {
 $('.pdp_img_grid').each(function() {
   var $pdp_img_grid = $(this);
   product_slider($pdp_img_grid);
 });
});



// Initialize Swiper on page load for all pdp_img_grid elements
function initializeSwipers() {
  $('.pdp_img_grid').each(function() {
    var $pdp_img_grid = $(this);
    if ($pdp_img_grid.length && $pdp_img_grid.find('.pdp-img-item').length && typeof Swiper !== 'undefined' && !$pdp_img_grid.hasClass('swiper-initialized')) {
      product_slider($pdp_img_grid);
    }
  });
}

// Try to initialize immediately if Swiper is already loaded
if (typeof Swiper !== 'undefined') {
  initializeSwipers();
} 

// Try again after a longer delay to catch any late-loading elements
setTimeout(initializeSwipers, 100);

});
